import log from "logbeacon";
import { rootStore } from "@store";
//TODO: 移动到packages

/**
 * 将标准UUID转换为14位数字
 * @param {string} uuid - 标准格式的UUID (如: "550e8400-e29b-41d4-a716-446655440000")
 * @returns {string} 14位数字字符串
 */
function uuidToNumeric(uuid: string): string {
  if (!uuid || typeof uuid !== "string") {
    throw new Error("Invalid UUID: must be a non-empty string");
  }

  // 移除连字符
  const hex = uuid.replace(/-/g, "");

  // 验证UUID格式 (32位十六进制字符)
  if (!/^[0-9a-fA-F]{32}$/.test(hex)) {
    throw new Error("Invalid UUID format: must be 32 hexadecimal characters");
  }

  // 截取后14位十六进制
  const truncated = hex.substring(hex.length - 14);

  // 转换为十进制数字
  const numeric = parseInt(truncated, 16).toString();

  return numeric;
}

// 初始化指纹
export async function initFingerprint() {
  if (typeof window === "undefined") {
    return;
  }
  try {
    const clientUuid = log.getOrCreateUUID();
    const numeric = uuidToNumeric(clientUuid);

    rootStore.user.fingerprint = numeric;
    return clientUuid;
  } catch (error) {
    log.error("[文案]Failed to load fingerprint:", error);
  }
}
